import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: oklch(0.9842 0.0034 247.86);
  padding: 24px;
  direction: rtl;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 480px;
`;

export const Card = styled.div`
  background: oklch(1 0 0);
  border-radius: 24px;
  box-shadow: 0 4px 6px -1px oklch(0 0 0 / 0.05), 0 10px 15px -3px oklch(0 0 0 / 0.05);
  overflow: hidden;
  border: 1px solid oklch(0.9288 0.0126 255.51);
`;

export const CardBody = styled.div`
  padding: 40px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 800;
  color: oklch(0.2077 0.0398 265.75);
  margin: 0;
  line-height: 1.3;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: oklch(55.44% 0.041 257.42);
  margin: 0;
  line-height: 1.5;
`;

export const Summary = styled.div`
  width: 100%;
  background-color: oklch(0.9842 0.0034 247.86);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 32px;
  border: 1px solid oklch(0.9683 0.0069 247.9);
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dashed oklch(0.9288 0.0126 255.51);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
`;

export const Label = styled.span`
  color: oklch(55.44% 0.041 257.42);
  font-size: 14px;
  font-weight: 500;
`;

export const Value = styled.span`
  color: oklch(0.2077 0.0398 265.75);
  font-size: 14px;
  font-weight: 700;
  direction: ltr;
`;

export const FreeShippingValue = styled.span`
  color: oklch(69.59% 0.149 162.48);
  font-size: 14px;
  font-weight: 700;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 16px;
  background-color: oklch(69.59% 0.149 162.48);
  color: oklch(1 0 0);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover {
    background-color: oklch(0.5959 0.1491 162.48);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const RetryButton = styled(PrimaryButton)`
  background-color: oklch(0.61 0.25 28.5);

  &:hover {
    background-color: oklch(0.4437 0.1613 26.9);
  }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  padding: 16px;
  background-color: transparent;
  color: oklch(55.44% 0.041 257.42);
  border: 1px solid oklch(0.9288 0.0126 255.51);
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover {
    background-color: oklch(0.9842 0.0034 247.86);
    color: oklch(0.2077 0.0398 265.75);
    border-color: oklch(0.869 0.0198 252.89);
  }
`;

